import $ from 'jquery';

$(function() {
    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    var preSelected = getParameterByName("selected");
    if (preSelected) {
        $("[name='your-recipient'] option").removeAttr('selected')
        .filter('[value*="'+preSelected+'"]')
            .attr('selected', true)
    }
});
